import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

function TPais() {
    const [paises, setPaises] = useState([]);
    const [paisesFiltrados, setPaisesFiltrados] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);
    const [modoEdicion, setModoEdicion] = useState(false);
    const [formulario, setFormulario] = useState({
        idPais: '',
        nomPais: ''
    });
    const [paginaActual, setPaginaActual] = useState(1);
    const [itemsPorPagina, setItemsPorPagina] = useState(10);

    const API_URL = '/api/paises';

    useEffect(() => {
        cargarPaises();
    }, []);

    useEffect(() => {
        filtrarPaises();
    }, [busqueda, paises]);

    const cargarPaises = async () => {
        try {
            const response = await axios.get(API_URL);
            setPaises(response.data);
            setPaisesFiltrados(response.data);
        } catch (error) {
            console.error('Error al cargar países:', error);
            alert('Error al cargar los países');
        }
    };

    const filtrarPaises = () => {
        if (!busqueda) {
            setPaisesFiltrados(paises);
            setPaginaActual(1);
            return;
        }

        const filtrados = paises.filter(pais =>
            pais.idPais?.toLowerCase().includes(busqueda.toLowerCase()) ||
            pais.nomPais?.toLowerCase().includes(busqueda.toLowerCase())
        );
        setPaisesFiltrados(filtrados);
        setPaginaActual(1);
    };

    const abrirModalNuevo = () => {
        setFormulario({
            idPais: '',
            nomPais: ''
        });
        setModoEdicion(false);
        setModalAbierto(true);
    };

    const abrirModalEditar = (pais) => {
        setFormulario({
            idPais: pais.idPais,
            nomPais: pais.nomPais
        });
        setModoEdicion(true);
        setModalAbierto(true);
    };

    const cerrarModal = () => {
        setModalAbierto(false);
        setFormulario({
            idPais: '',
            nomPais: ''
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formulario.idPais.trim() || !formulario.nomPais.trim()) {
            alert('Todos los campos son requeridos');
            return;
        }

        if (formulario.idPais.length > 2) {
            alert('El código del país no puede tener más de 2 caracteres');
            return;
        }

        try {
            if (modoEdicion) {
                await axios.put(`${API_URL}/${formulario.idPais}`, formulario);
                alert('País actualizado exitosamente');
            } else {
                await axios.post(API_URL, formulario);
                alert('País creado exitosamente');
            }
            cargarPaises();
            cerrarModal();
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar el país');
        }
    };

    const eliminar = async (id) => {
        if (window.confirm('¿Está seguro de eliminar este país?')) {
            try {
                await axios.delete(`${API_URL}/${id}`);
                alert('País eliminado exitosamente');
                cargarPaises();
            } catch (error) {
                console.error('Error al eliminar:', error);
                alert('Error al eliminar el país');
            }
        }
    };

    const exportarExcel = () => {
        const datosExportar = paisesFiltrados.map(pais => ({
            'Código': pais.idPais,
            'Nombre': pais.nomPais
        }));

        const worksheet = XLSX.utils.json_to_sheet(datosExportar);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Países');
        XLSX.writeFile(workbook, 'paises.xlsx');
    };

    // Paginación
    const indiceUltimo = paginaActual * itemsPorPagina;
    const indicePrimero = indiceUltimo - itemsPorPagina;
    const paisesActuales = paisesFiltrados.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(paisesFiltrados.length / itemsPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
    };

    const cambiarItemsPorPagina = (e) => {
        setItemsPorPagina(Number(e.target.value));
        setPaginaActual(1);
    };

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Gestión de Países</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        className="input-busqueda"
                        placeholder="Buscar..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>
                        ➕ Nuevo País
                    </button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>
                        📊 Exportar a Excel
                    </button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Nombre del País</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paisesActuales.length === 0 ? (
                            <tr>
                                <td colSpan="3" className="sin-datos">No hay países para mostrar</td>
                            </tr>
                        ) : (
                            paisesActuales.map(pais => (
                                <tr key={pais.idPais}>
                                    <td>{pais.idPais}</td>
                                    <td>{pais.nomPais}</td>
                                    <td>
                                        <button
                                            onClick={() => abrirModalEditar(pais)}
                                            className="btn-accion"
                                            title="Editar"
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            onClick={() => eliminar(pais.idPais)}
                                            className="btn-accion"
                                            title="Eliminar"
                                        >
                                            🗑️
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="paginacion-container">
                <div className="paginacion-info">
                    <span>
                        Mostrando {indicePrimero + 1} a {Math.min(indiceUltimo, paisesFiltrados.length)} de {paisesFiltrados.length} registros
                    </span>
                    <select
                        value={itemsPorPagina}
                        onChange={cambiarItemsPorPagina}
                        className="select-registros"
                    >
                        <option value={5}>5 por página</option>
                        <option value={10}>10 por página</option>
                        <option value={20}>20 por página</option>
                        <option value={50}>50 por página</option>
                    </select>
                </div>

                <div className="paginacion-controles">
                    <button
                        onClick={() => cambiarPagina(1)}
                        disabled={paginaActual === 1}
                        className="btn-paginacion"
                        title="Primera página"
                    >
                        ⏮️
                    </button>
                    <button
                        onClick={() => cambiarPagina(paginaActual - 1)}
                        disabled={paginaActual === 1}
                        className="btn-paginacion"
                    >
                        ◀️
                    </button>

                    {[...Array(totalPaginas)].map((_, index) => {
                        const numeroPagina = index + 1;
                        if (
                            numeroPagina === 1 ||
                            numeroPagina === totalPaginas ||
                            (numeroPagina >= paginaActual - 1 && numeroPagina <= paginaActual + 1)
                        ) {
                            return (
                                <button
                                    key={numeroPagina}
                                    onClick={() => cambiarPagina(numeroPagina)}
                                    className={`btn-numero-pagina ${paginaActual === numeroPagina ? 'activo' : ''}`}
                                >
                                    {numeroPagina}
                                </button>
                            );
                        } else if (
                            numeroPagina === paginaActual - 2 ||
                            numeroPagina === paginaActual + 2
                        ) {
                            return <span key={numeroPagina}>...</span>;
                        }
                        return null;
                    })}

                    <button
                        onClick={() => cambiarPagina(paginaActual + 1)}
                        disabled={paginaActual === totalPaginas}
                        className="btn-paginacion"
                    >
                        ▶️
                    </button>
                    <button
                        onClick={() => cambiarPagina(totalPaginas)}
                        disabled={paginaActual === totalPaginas}
                        className="btn-paginacion"
                        title="Última página"
                    >
                        ⏭️
                    </button>
                </div>
            </div>

            {/* Modal */}
            {modalAbierto && (
                <div className="modal-overlay">
                    <div className="modal-contenido">
                        <div className="modal-header">
                            <h3>{modoEdicion ? 'Editar País' : 'Nuevo País'}</h3>
                            <button onClick={cerrarModal} className="btn-cerrar">×</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Código del País *</label>
                                <input
                                    type="text"
                                    value={formulario.idPais}
                                    onChange={(e) => setFormulario({ ...formulario, idPais: e.target.value.toUpperCase() })}
                                    required
                                    maxLength={2}
                                    placeholder="Ej: AR, BR, UY"
                                    disabled={modoEdicion}
                                />
                            </div>

                            <div className="form-group">
                                <label>Nombre del País *</label>
                                <input
                                    type="text"
                                    value={formulario.nomPais}
                                    onChange={(e) => setFormulario({ ...formulario, nomPais: e.target.value })}
                                    required
                                    maxLength={15}
                                    placeholder="Ingrese el nombre del país"
                                />
                            </div>

                            <div className="modal-footer">
                                <button type="button" onClick={cerrarModal} className="btn btn-cancelar">
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-guardar">
                                    {modoEdicion ? 'Actualizar' : 'Guardar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TPais;
